import { OrderParams } from "pages/order/OrderPage";
import { useParams } from "react-router-dom";
import { ChecklistParams } from "pages/checklist/ChecklistPage";
import Crumb from "features/breadcrumbs/Crumb";

const InstallProductCrumb: React.FC = () => {
  const { orderId, checklistId } = useParams<OrderParams & ChecklistParams>();

  return (
    <Crumb to={`/orders/view/${orderId}/checklist/${checklistId}/products`}>
      Lägg till produkt
    </Crumb>
  );
};

export default InstallProductCrumb;
